import { addKeyword, editKeyword, delKeyword, getPage, getDetail,saveGreeting,getGreeting } from '@/api/keywordReply'

class keywordReplyDTO {
    // 关键词新增
    static addKeyword(params) {
        return new Promise((resolve, reject) => {
            addKeyword(params).then(res => {
                resolve(res)
            })
        })
    }

    // 关键词修改
    static editKeyword(params) {
        return new Promise((resolve, reject) => {
            editKeyword(params).then(res => {
                resolve(res)
            })
        })
    }

    // 关键词删除
    static delKeyword(params) {
        return new Promise((resolve, reject) => {
            delKeyword(params).then(res => {
                resolve(res)
            })
        })
    }

    // 分页查询关键词
    static getPage(params) {
        return new Promise((resolve, reject) => {
            getPage(params).then(res => {
                resolve(res)
            })
        })
    }

    // 查询关键词详情
    static getDetail(params) {
        return new Promise((resolve, reject) => {
            getDetail(params).then(res => {
                resolve(res)
            })
        })
    }
    // 公众号欢迎语设置
    static saveGreeting(params) {
        return new Promise((resolve, reject) => {
          saveGreeting(params).then(res => {
                resolve(res)
            }).catch(()=>{
              resolve({code:500})
            })
        })
    }
    // 查询公众号欢迎语设置
    static getGreeting(params) {
        return new Promise((resolve, reject) => {
          getGreeting(params).then(res => {
                resolve(res)
            }).catch(()=>{
              resolve({code:500})
            })
        })
    }
}

export { keywordReplyDTO }